<template>
    <v-container class="mt-6">
        <v-card v-if="primaryDetails" class="px-10" max-width="100%">
            <v-row>
                <v-col cols="12" sm="12" class="pa-0 py-2">
                        <!-- <v-card-title>{{ localize('company') }} </v-card-title> -->
                        <h1>{{ contactDetails.nameCompany }} - {{ primaryDetails.id }}</h1>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" class="pa-0"
                    >
                    <v-card-title> <TranslatableStringComponent :tstring="{string: 'firstName'}" /> </v-card-title>
                    <v-card-text class="mx-auto">{{
                        contactDetails.nameFirst || '--'
                    }}</v-card-text>
                    </v-col
                >
                <v-col cols="12" sm="6" class="pa-0"
                    >
                    <v-card-title><TranslatableStringComponent :tstring="{string: 'lastName'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        contactDetails.nameLast || '--'
                    }}</v-card-text>
                    </v-col
                >
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'primaryEmailAddress'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        contactDetails.email1 || '--'
                    }}</v-card-text></v-col
                >
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'primaryPhoneNo'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        contactDetails.phone1 || '--'
                    }}</v-card-text></v-col
                >
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'addressLine', variables:[{var: '1'}] }" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        contactDetails.address1 || '--'
                    }}</v-card-text></v-col
                >
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'addressLine',variables:[{var: '2'}]}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        contactDetails.address2 || '--'
                    }}</v-card-text></v-col
                >
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'cityTown'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        contactDetails.addressCity || '--'
                    }}</v-card-text></v-col
                >
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'stateProvince'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        contactDetails.addressState || '--'
                    }}</v-card-text></v-col
                >
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'country'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        contactDetails.addressCountry || '--'
                    }}</v-card-text></v-col
                >
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'zipPostalCode'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        contactDetails.addressPostalCode || '--'
                    }}</v-card-text></v-col
                >
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'paymentTerms'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        primaryDetails && primaryDetails.ARTerm  && primaryDetails.ARTerm.name || '--'
                    }}</v-card-text></v-col
                >
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'priceList'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        primaryDetails && primaryDetails.PriceList  && primaryDetails.PriceList.name || '--'
                    }}</v-card-text></v-col
                >
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'taxExempt'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        primaryDetails && !primaryDetails.taxable ? 'Yes' : 'No' 
                    }}</v-card-text></v-col
                >
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'accountingEmail'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        primaryDetails && primaryDetails.accountingEmail1 || '--'
                    }}</v-card-text></v-col
                >
            </v-row>
            <v-row>
                <v-col cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'onCreditHold'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        primaryDetails && primaryDetails.isOnHold? 'Yes' : 'No'
                    }}</v-card-text></v-col
                >
                <v-col v-if="primaryDetails && primaryDetails.taxId" cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'taxId'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        primaryDetails.taxId
                    }}</v-card-text></v-col
                >
            </v-row>
            <v-row>
                <v-col v-if="primaryDetails && primaryDetails.isFreeGroundAt && primaryDetails.isFreeGroundAt !== 49" cols="12" sm="6" class="pa-0"
                    ><v-card-title><TranslatableStringComponent :tstring="{string: 'freeGroundAt'}" /></v-card-title>
                    <v-card-text class="mx-auto">{{
                        primaryDetails && primaryDetails.isFreeGroundAt
                    }}</v-card-text></v-col
                >
            </v-row>    
        </v-card>
        <v-card v-else class="pa-10">
            <v-alert dense outlined type="info" color="primary"><TranslatableStringComponent :tstring="{string: 'customerDetailsAre1', variables:[{var: 'empty', tag: 'strong'}]}" />
            </v-alert>
        </v-card>
    </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue'

export default {
    name: 'CardCustomerDetails',
    components: {
        TranslatableStringComponent,
    },
    data() {
        return {
            skeleleton: true,
            alert: false,
        }
    },
    computed: {
        ...mapGetters({
            primaryCustomer: 'auth/primaryCustomer',
        }),
        primaryDetails() {
            return this.primaryCustomer
        },
        contactDetails() {
            return this.primaryCustomer?.CustomerPrimaryContact
        },
    },
    methods: {},
}
</script>
